const getLabelStatusPermintaanMobil = (status) => {
  switch (status) {
    case 0:
      return "Tunggu Dibuat";
    case 1:
      return "Tunggu PNJ";
    case 2:
      return "Tunggu Disetujui";
    case 3:
      return "Tunggu Diproses";
    case 4:
      return "Selesai / Diterima";
    default:
      return "Ditolak";
  }
};
export default getLabelStatusPermintaanMobil;
